class CustomDrawer extends HTMLElement {
  constructor() {
    super()

    this.header = document.querySelector('.site-header');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector(`#${this.id}-Overlay`).addEventListener('click', this.close.bind(this));

    const links = document.querySelectorAll(this.dataset.triggerSelector);
    links.forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.open(link);
      });
      link.addEventListener('keydown', (evt) => {
        if (evt.code.toUpperCase() === 'SPACE') {
          evt.preventDefault();
          this.open(link);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.dataset.setHeaderOpen === 'true') this.header.classList.add('header--drawer-is-open');

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(this, focusElement);
      },
      { once: true }
    );

    // updateCartNote();
    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (this.dataset.setHeaderOpen === 'true') this.header.classList.remove('header--drawer-is-open');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    document.querySelector('.quick-add-modal-cart-upsell[open]')?.removeAttribute('open');

    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('custom-drawer', CustomDrawer)

class CartDrawer extends CustomDrawer {
  constructor() {
    super();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(this, focusElement);
      },
      { once: true }
    );

    // updateCartNote();
    document.body.classList.add('overflow-hidden');

    this.handleUpsell();

  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    this.handleUpsell();

    setTimeout(() => {
      this.querySelector(`#${this.id}-Overlay`).addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  handleUpsell(){
    const upsells = document.querySelectorAll('.drawer-upsell');

    if(upsells.length > 0){
      upsells.forEach(upsell => {
        const upsellItems = upsell.querySelectorAll('.drawer-upsell_item')
          
        if(upsellItems.length === 0){
          upsell.classList.add('hide');
        }
      })
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return this.getSectionDOM(html, selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: `#${this.id}`,
      },
      {
        id: 'cart-drawer-btn',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-drawer-btn',
        section: 'cart-drawer-btn',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class DrawerProductForm extends HTMLElement{
  constructor(){
    super();

    this.productForm = this.querySelector('[data-product-form]');
    this.addToCart = this.querySelector('[data-add-to-cart]');
    this.addToCartText = this.querySelector('[data-add-to-cart-text]');
    this.loader = this.querySelector('[data-loader]');
    
    this.cartDrawer =  document.querySelector('#CartDrawer');
    this.cartDrawerInner =  document.querySelector('#CartDrawer .drawer__inner');

    this.cartRoutes = JSON.parse(
      document.querySelector('[data-cart-routes]').innerHTML
    );
  }

  connectedCallback(){
    this.productForm.addEventListener('submit', this.initAddToCart.bind(this))
  }

  initAddToCart(evt){
    evt.preventDefault();

    this.handleButtonLoadingState(true);
    this.addItemToCart(this.productForm);
  }

  addItemToCart(form) {
    const self = this;

    fetch(this.cartRoutes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: theme.Helpers.serialize(form) + '&sections=cart-drawer,cart-drawer-btn&sections_url=' + encodeURIComponent(window.location.pathname)
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }

        // self._hideErrorMessage();
        // self._setupCartPopup(json);
        self.setupCartDrawer(json);
        self.handleButtonLoadingState(false);
        self.closeModal();
      })
      .catch(function(error) {
        // self._showErrorMessage(
        //   error.isFromServer && error.message.length
        //     ? error.message
        //     : theme.strings.cartError
        // );
        self.handleButtonLoadingState(false);
        // eslint-disable-next-line no-console
        console.log(error);
      });
  }

  closeModal(){
    this.modal?.hide();
  }

  setupCartDrawer(item){
    this.cartDrawer.renderContents(item);
  }

  handleButtonLoadingState(isLoading) {
    if (isLoading) {
      this.addToCart.setAttribute('aria-disabled', true);
      // this.addToCartText.classList.add('hide');
      this.loader.classList.remove('hide');

    } else {
      this.addToCart.removeAttribute('aria-disabled');
      // this.addToCartText.classList.remove('hide');
      this.loader.classList.add('hide');
    }
  }
}

customElements.define('drawer-product-form', DrawerProductForm);

class VariantQuickAdd extends DrawerProductForm{
  constructor(){
    super();

  }

  connectedCallback(){}

  init(){
    this.setQuickAddModal();    
    this.productForm = this.querySelector('[data-product-form]');
    this.addToCart = this.querySelector('[data-add-to-cart]');
    this.addToCartText = this.querySelector('[data-add-to-cart-text]');
    this.loader = this.querySelector('[data-loader]');
    
    this.cartDrawer =  document.querySelector('#CartDrawer');
    this.cartDrawerInner =  document.querySelector('#CartDrawer .drawer__inner');
    this.singleOptions = this.querySelectorAll('.single-option-selector');

    this.cartRoutes = JSON.parse(
      document.querySelector('[data-cart-routes]').innerHTML
    );

    this.productForm.addEventListener('submit', this.initAddToCart.bind(this));

    this.singleOptions.forEach(
      function(option) {
        option.addEventListener('change', this.onSelectChange.bind(this));
      }.bind(this)
    );

    this.options = {
      product: this.productSingleObject
    };
  }

  setQuickAddModal(){
    const modalSelector = `#${this.dataset.modalId}`;

    const modal = document.querySelector(modalSelector);

    this.modal = modal;
    this.featuredImage = this.modal.querySelector('.quick-add-product-infos img');
    this.priceContainer = this.modal.querySelector('[data-price]');

    const productJson = this.modal.productScriptJson;

    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.product = JSON.parse(productJson.innerHTML);

    this.updateMasterSelect(this.product.variants[0]);
    this.updateImage(this.product.variants[0]);
    this.updatePrice(this.product.variants[0]);
  }

  getCurrentOptions() {
    const result = [];

    this.singleOptions.forEach(function(option) {
      const type = option.getAttribute('type');
      const isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

      if (!isRadioOrCheckbox || option.checked) {
        result.push({
          value: option.value,
          index: option.getAttribute('data-index')
        });
      }
    });

    return result;
  }

  getVariantFromOptions() {
    const selectedValues = this.getCurrentOptions();
    const variants = this.product.variants;

    const found = variants.find(function(variant) {
      return selectedValues.every(function(values) {
        return variant[values.index] === values.value;
      });
    });

    return found;
  }

  onSelectChange(){
    const variant = this.getVariantFromOptions();

    this.modal.dispatchEvent(
      new CustomEvent('variantChange', {
        detail: {
          variant: variant
        },
        bubbles: true,
        cancelable: true
      })
    );

    if (!variant) {
      return;
    }


    this.currentVariant = variant;

    this.updateMasterSelect(variant);
    this.updateImage(variant);
    this.updatePrice(variant);

  }

  updateImage(variant) {
    const variantImage = variant.featured_image || {};

    if (!variant.featured_image) return;

    this.featuredImage.src = variantImage.src;
  }

  updatePrice(variant){

    const regularPrices = this.priceContainer.querySelectorAll(
      '[data-regular-price]'
    );
    const salePrice = this.priceContainer.querySelector(
      '[data-sale-price]'
    );
 
    const formatRegularPrice = function(regularPriceElement, price) {
      regularPriceElement.innerHTML = theme.Currency.formatMoney(
        price,
        theme.moneyFormat
      );
    };

    // On sale
    if (variant.compare_at_price > variant.price) {
      regularPrices.forEach(function(regularPrice) {
        formatRegularPrice(regularPrice, variant.compare_at_price);
      });
      salePrice.innerHTML = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
    } else {
      // Regular price
      regularPrices.forEach(function(regularPrice) {
        formatRegularPrice(regularPrice, variant.price);
      });
    }
  }

  /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
  updateMasterSelect(variant){
    const masterSelect = this.querySelector('.product-form__variants');

    if (!masterSelect) return;
    masterSelect.value = variant.id;
  }
}

customElements.define('variant-quick-add', VariantQuickAdd);

// quick add modal

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    const content = this.querySelector('.quick-add-modal__content');
    content.classList.add('anim-reverse');
    setTimeout(() => {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    content.classList.remove('anim-reverse');
    }, 300);
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

customElements.define(
  'quick-add-modal',
  class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      this.addEventListener('.product-template__container .product-form:loaded', ({ target }) => {
        target.addPreProcessCallback(this.preprocessHTML.bind(this));
      });
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

          const productElement = responseHTML.querySelector('.product-template__container .product-form');

          this.productScriptJson = responseHTML.querySelector('[id^="ProductJson-"]');

          this.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');

          const quickAddComponent = this.querySelector('variant-quick-add');
          quickAddComponent.init();
        });
    }

    preprocessHTML(productElement) {
      productElement.classList.forEach((classApplied) => {
        if (classApplied.startsWith('color-') || classApplied === 'gradient')
          this.modalContent.classList.add(classApplied);
      });
      this.preventDuplicatedIDs(productElement);
      this.removeDOMElements(productElement);
      this.removeGalleryListSemantic(productElement);
      this.preventVariantURLSwitching(productElement);
    }

    preventVariantURLSwitching(productElement) {
      productElement.setAttribute('data-update-url', 'false');
    }

    removeDOMElements(productElement) {
      const pickupAvailability = productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs(productElement) {
      const sectionId = productElement.dataset.section;

      const oldId = sectionId;
      const newId = `quickadd-${sectionId}`;
      productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
      Array.from(productElement.attributes).forEach((attribute) => {
        if (attribute.value.includes(oldId)) {
          productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
        }
      });

      productElement.dataset.originalSection = sectionId;
    }

    removeGalleryListSemantic(productElement) {
      const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
    }
  }
);

// updateCartNote();

// window.addEventListener('resize', updateCartNote);

// function updateCartNote(){
//   const cartNoteDetails = document.querySelector('.cart-drawer__footer .cart__note details');

//   if(cartNoteDetails){
//     if(window.innerWidth <= 920 || screen.width <= 920){
//       cartNoteDetails.removeAttribute('open');
//     } else{
//       cartNoteDetails.setAttribute('open', '');
//     }
//   }
// }